<div class="price text-center" id="price">
  <div *ngIf="(userState | async).user !== null
              && ((userState | async).user.type === 2)"
  >
    <h1>Select the right package</h1>
  </div>

  <div class="pb-3"
       *ngIf="(userState | async).user !== null
              && ((userState | async).user.type === 1)
              && (paymentState | async).pricing.length > 0
          "
  >
    <h6 class="content-header my-4">Pricing</h6>
<!--    <h3 class="mb-5">How many followers does the account have?</h3>-->
    <div class="col-lg-6 offset-lg-3 p-0">
      <ngx-slider [(value)]="followersSlider" [options]="options"></ngx-slider>
    </div>
  </div>

  <div class="btn-group">
    <!--        <button class="btn" [ngClass]="{'btn-blue': subscriptionPeriod === 0, 'btn-default': subscriptionPeriod !== 0}" (click)="setSubscriptionPeriod(0)">One time</button>-->
    <button class="btn" [ngClass]="{'btn-blue': subscriptionPeriod === 1, 'btn-default': subscriptionPeriod !== 1}" (click)="setSubscriptionPeriod(1)">Monthly</button>
    <button class="btn" [ngClass]="{'btn-blue': subscriptionPeriod === 2, 'btn-default': subscriptionPeriod !== 2}" (click)="setSubscriptionPeriod(2)">
      Yearly
      <span class="promo-info "
             [ngClass]="{'promo-white': subscriptionPeriod === 2, 'promo-orange': subscriptionPeriod !== 2}"
      >
        70% OFF!
      </span>
    </button>
  </div>
  <p class="text-medium mt-4" *ngIf="subscriptionPeriod === 1 || subscriptionPeriod === 2">You can cancel your subscription at any time</p>

  <div class="text-center my-5" *ngIf="(paymentState | async).pricing.length > 0">
    <div class="p-0 row mx-auto">
      <div
        class="p-0 mb-3" [ngClass]="{'col-md-4' : (userState | async).user !== null
              && ((userState | async).user.type !== 1
                || (
                  (userState | async).user.type === 1
                  && (price.permissions['auditor.limit'].followers_count === undefined
                      || price.permissions['auditor.limit'].followers_count === -1
                      || (price.permissions['auditor.limit'].followers_count > 0
                          && followersSlider === price.permissions['auditor.limit'].followers_count
                          && ((profileState | async).profileDetail === null
                            || ((profileState | async).profileDetail !== null
                                && (
                                  getMinValue((profileState | async).profileDetail.followed_by, 1000000) <=  price.permissions['auditor.limit'].followers_count
                                  || (profileState | async).profileDetail.demo !== undefined)
                                )
                          )
                         )
                      )
                  )
              ),
              'offset-md-4': (userState | async).user !== null
              && ((userState | async).user.type === 1)
              && (price.permissions['auditor.limit'].followers_count === undefined
                      || price.permissions['auditor.limit'].followers_count === -1
                      || (price.permissions['auditor.limit'].followers_count > 0
                          && followersSlider === price.permissions['auditor.limit'].followers_count
                          && ((profileState | async).profileDetail === null
                            || ((profileState | async).profileDetail !== null
                                && (
                                  (profileState | async).profileDetail.followed_by <  price.permissions['auditor.limit'].followers_count
                                  || (profileState | async).profileDetail.demo !== undefined)
                                )
                          )
                         )

                  )
              }"
        *ngFor="let price of (paymentState | async).pricing"
      >

        <div class="p-0"
             *ngIf="(userState | async).user !== null
              && ((userState | async).user.type !== 1
                || (
                  (userState | async).user.type === 1
                  && (price.permissions['auditor.limit'].followers_count === undefined
                      || price.permissions['auditor.limit'].followers_count === -1
                      || (price.permissions['auditor.limit'].followers_count > 0
                          && followersSlider === price.permissions['auditor.limit'].followers_count
                          && ((profileState | async).profileDetail === null
                            || ((profileState | async).profileDetail !== null
                                && (
                                  (profileState | async).profileDetail.followed_by <  price.permissions['auditor.limit'].followers_count
                                    || (profileState | async).profileDetail.demo !== undefined)
                                )
                          )
                          )
                      )
                  )
              )"

        >
          <app-price-box [price]="price"></app-price-box>
        </div>
      </div>
    </div>
  </div>
  <img class="pricing-bg" src="assets/images/dots.png"/>
</div>
